import PropTypes from 'prop-types';
import { Chip, Typography } from '@mui/material';

import { STATUS_TYPES, componentsSize } from 'constants/components';

const statusProps = {
  [STATUS_TYPES.ACTIVE]: {
    label: 'Active',
    color: 'success',
  },
  [STATUS_TYPES.DRAFT]: {
    label: 'Draft',
    color: 'warning',
  },
  [STATUS_TYPES.ARCHIVED]: {
    label: 'Archived',
    color: 'error',
  },
};

const styles = {
  statusChip: (size) => ({
    borderRadius: 6,
    cursor: 'inherit',
    ...(size === componentsSize.small && {
      width: 80,
      height: 20,
    }),
    ...(size === componentsSize.medium && {
      width: 120,
      height: { xs: 28, md: 32 },
    }),
    ...(size === componentsSize.large && {
      width: { xs: 120, md: 168 },
      height: { xs: 28, md: 56 },
    }),
  }),
};

const Status = ({ statusType, size = componentsSize.medium, customStyles = null }) => {
  const { color, label } = statusProps[statusType] || {};

  const isSmallSize = size === componentsSize.small;

  return (
    <Chip
      size={size}
      color={color}
      label={
        <Typography
          variant={isSmallSize ? 'overline' : 'body2-bold'}
          color={isSmallSize ? 'text.secondary' : 'text.primary'}
          component="span"
        >
          {isSmallSize ? label?.toUpperCase() : label}
        </Typography>
      }
      sx={[styles.statusChip(size), customStyles]}
    />
  );
};

Status.propTypes = {
  statusType: PropTypes.oneOf(Object.values(STATUS_TYPES)).isRequired,
  size: PropTypes.oneOf(Object.values(componentsSize)),
  customStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
};
export default Status;
